export default __webpack_public_path__ + "./images/vn.0e283eae.png";